import { create } from 'zustand';

import type { CardId } from './types';

export interface CardDragPreview {
  deltaX: number;
  deltaY: number;
}

export interface ClusterPlacementPreview {
  clusterId: CardId;
  draggedCardId: CardId;
  placeholderBeforeChildId: CardId | null;
  size: {
    height: number;
    width: number;
  };
}

interface BoardDragPreviewState {
  cardDragPreviews: Record<CardId, CardDragPreview>;
  clusterPlacement: ClusterPlacementPreview | null;
}

interface BoardDragPreviewActions {
  clearCardDragPreviews: () => void;
  clearClusterPlacement: () => void;
  setCardDragPreviews: (cardDragPreviews: Record<CardId, CardDragPreview>) => void;
  setClusterPlacement: (clusterPlacement: ClusterPlacementPreview | null) => void;
}

export type BoardDragPreviewStore = BoardDragPreviewState & BoardDragPreviewActions;

export const useBoardDragPreviewStore = create<BoardDragPreviewStore>((set) => ({
  cardDragPreviews: {},
  clusterPlacement: null,
  clearCardDragPreviews: () => set({ cardDragPreviews: {} }),
  clearClusterPlacement: () => set({ clusterPlacement: null }),
  setCardDragPreviews: (cardDragPreviews) => set({ cardDragPreviews }),
  setClusterPlacement: (clusterPlacement) => set({ clusterPlacement }),
}));
